// This dictionary contains 1 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.
import { localization } from "../localizationManager";

export var italianStrings = {
  groupButton: "Raggruppa",
  ungroupButton: "Dividi",
  selectButton: "Selezionami",
  hideColumn: "Nascondi colonna",
  showColumn: "Mostra colonna",
  makePrivateColumn: "Rendi la colonna privata",
  makePublicColumn: "Rendi la colonna pubblica",
  moveToDetail: "Sposta in Dettaglio",
  showAsColumn: "Mostra come Colonna",
  filterPlaceholder: "Cerca...",
  removeRows: "Rimuovi righe",
  showLabel: "Mostra",
  entriesLabel: "voci",
  visualizer_text: "Parole in tabella",
  visualizer_wordcloud: "Nuvola di parole",
  visualizer_histogram: "Istogramma",
  visualizer_number: "Media",
  visualizer_choices: "Tabella",
  visualizer_selectBase: "Grafico",
  // visualizer_matrix: "Chart",
  chartType_bar: "Grafico a barre",
  chartType_vbar: "Grafico a barre verticali",
  chartType_stackedbar: "Grafico a barre sovrapposte",
  chartType_doughnut: "Grafico a ciambella",
  chartType_pie: "Grafico a torta",
  chartType_scatter: "Grafico a dispersione",
  chartType_gauge: "Grafico Gauge",
  chartType_bullet: "Punto",
  hideButton: "Nascondi",
  makePrivateButton: "Rendi privato",
  makePublicButton: "Rendi pubblico",
  showButton: "Mostra",
  filter: "Filtro",
  resetFilter: "Cancella filtro",
  changeLocale: "Cambia lingua",
  clearButton: "Cancella",
  addElement: "Scegli la domanda da mostrare...",
  defaultOrder: "Ordine di Default",
  ascOrder: "Ascendente",
  descOrder: "Discendente",
  showMinorColumns: "Mostra colonne secondarie",
  otherCommentTitle: "Altri punti e commenti",
  showPercentages: "Mostra percentuali",
  hidePercentages: "Nascondi percentuali",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Excel",
  csvDownloadCaption: "CSV",
  saveDiagramAsPNG: "Scarica il grafico in formato png",
  hideEmptyAnswers: "Nascondi risposte vuote",
  showEmptyAnswers: "Mostra risposte vuote",
  "topNValueText-1": "Tutte le risposte",
  topNValueText5: "Top 5 risposte",
  topNValueText10: "Top 10 risposte",
  topNValueText20: "Top 20 risposte",
  hideMissingAnswers: "Nascondi le risposte mancanti",
  showMissingAnswers: "Mostra le risposte mancanti",
  missingAnswersLabel: "Risposte mancanti",
  noVisualizerForQuestion: "Questo tipo di domanda non è ancora stato visualizzato",
  noResults: "Non ci sono ancora risultati",
  showPerValues: "Per Valori",
  showPerColumns: "Per Colonne",
  answer: "Risposta",
  correctAnswer: "Risposta esatta: ",
  percent: "Percentuale",
  responses: "Risposte"
};

localization.locales["it"] = italianStrings;
localization.localeNames["it"] = "Italiano";

// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// undefined.correctAnswer: "Correct answer: " => "Risposta esatta: "